import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
// import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import LinesEllipsis from 'react-lines-ellipsis';

import ReactStars from 'react-rating-stars-component';
import { getLinkLtik } from 'constants/LTIData';
import classes from './CourseCard.module.css';

const url = window.location.pathname.split('/');

const CourseData = props => {
  const { t } = useTranslation(['course']);
  return (
    <Button
      className={classes.cardButton}
      component={Link}
      to={
        getLinkLtik() !== null
          ? `/c/${props.courseData.idCourse}/?ltik=${getLinkLtik()}`
          : url[2] === 'a'
          ? `/a/c/${props.courseData.idCourse}`
          : `/c/${props.courseData.idCourse}`
      }
    >
      <Card className={classes.courseCard}>
        <CardMedia
          component="img"
          height="180"
          image={props.courseData.bigPath}
          alt={props.courseData.name}
          className={classes.imageCourse}
        />
        <CardContent className={classes.infoCourse}>
          <LinesEllipsis
            text={props.courseData.name}
            maxLine="3"
            ellipsis="..."
            trimRight
            basedOn="letters"
            className={classes.courseName}
          />
          <Typography
            className={classes.durationText}
            noWrap
            component="p"
            color="textSecondary"
          >
            {props.courseData.hrs > 0 ? (
              <span>
                {t('duration')}: {props.courseData.hrs} hrs
              </span>
            ) : (
              ''
            )}
          </Typography>
          {props.courseData.reviews == 1 && (
            <aside className={classes.rating}>
              <ReactStars
                edit={false}
                count={5}
                isHalf={true}
                size={24}
                activeColor="#e6a817"
                emptyStarColor="#d6d6d6"
                value={props.courseData.votes}
              />
            </aside>
          )}
          <span className={classes.extraData}>
            {props.typeOrg == '1' ? (
              <strong className={classes.txtFull}>
                {t('free')}
              </strong>
            ) : props.typeOrg == '4' &&
              props.courseData.monto == 0 ? (
              <strong className={classes.txtFull}>
                {t('free')}
              </strong>
            ) : props.courseData.monto > 0 &&
              props.idAcademy !== 2190 ? (
              <strong>
                <ShoppingCartIcon className={classes.shopIcon} />
                {props.courseData.currencySymbol}{' '}
                {props.courseData.monto}{' '}
                <span className={classes.currency}>
                  {props.courseData.currency}
                </span>
              </strong>
            ) : (
              ''
            )}
          </span>
        </CardContent>
      </Card>
    </Button>
  );
};

CourseData.propTypes = {
  // eslint-disable-next-line react/require-default-props
  courseData: PropTypes.data,
  // eslint-disable-next-line react/require-default-props
  typeOrg: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idAcademy: PropTypes.number
};

export default CourseData;
